<template>
  <div class="header__icons">
    <v-menu offset-y nudge-top="-20" v-if="currentRole == 7">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" height="40px" width="40px"
          style="min-width: unset; left: 10px; border-radius: var(--8, 8px)" class="ml-5 mr-3 p-0 genaralIcons"
          color="#3f0e40">
          <v-icon color="white" size="40">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list class="top-left-menu">
        <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
          @click="backToReceivedBasket">
          <v-list-item-icon class="ml-3">
            <v-icon>mdi-arrow-left</v-icon>
          </v-list-item-icon>
          <v-list-item-title>إرجاع للمستلمة</v-list-item-title>
        </v-list-item>


        <!-- ========================================================================================================== -->
        <!-- back to customer service recieved basket -->
        <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
          @click="backToCustomerServiceRecievedBasket">
          <v-list-item-icon class="ml-3">
            <v-icon>mdi-arrow-left</v-icon>
          </v-list-item-icon>
          <v-list-item-title>إرجاع للمستلمة لخدمة العملاء</v-list-item-title>
        </v-list-item>
        <!-- ========================================================================================================== -->


        <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
          @click="handleTransferFilter">
          <v-list-item-icon class="ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="14.513" height="16.448" viewBox="0 0 14.513 16.448">
              <path id="Icon_material-subdirectory-arrow-right" :fill="$store.getters.isDark ? '#ffffff' : '#000000'"
                data-name="Icon material-subdirectory-arrow-right"
                d="M20.513,16.643l-5.805,5.805-1.374-1.374,3.473-3.464H6V6H7.935v9.675h8.872l-3.473-3.464,1.374-1.374Z"
                transform="translate(-6 -6)" />
            </svg>
          </v-list-item-icon>
          <v-list-item-title>تحويل الطلب</v-list-item-title>
        </v-list-item>
        <v-list-item style="border-bottom: 2px solid #ededed" class="black--text font-weight-bold"
          @click="moveToNeedAction">
          <v-list-item-icon class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.121" height="17.121" viewBox="0 0 17.121 17.121">
              <g id="Icon_feather-arrow-up-right" data-name="Icon feather-arrow-up-right"
                transform="translate(-9.439 -9.439)">
                <path id="Path_5860" data-name="Path 5860" d="M10.5,25.5l15-15" fill="none"
                  :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.5" />
                <path id="Path_5861" data-name="Path 5861" d="M10.5,10.5h15v15" fill="none"
                  :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.5" />
              </g>
            </svg>
          </v-list-item-icon>
          <v-list-item-title>نقل الي سله التحويل</v-list-item-title>
        </v-list-item>
        <v-list-item style="border-bottom: 2px solid #ededed" class="black--text font-weight-bold"
          @click="convertRequest" v-if="!showFeaturedProcess">
          <v-list-item-icon class="ml-2">
            <SendToQualityIcon />
          </v-list-item-icon>
          <v-list-item-title>نقل الي الجوده</v-list-item-title>
        </v-list-item>
        <v-list-item style="border-bottom: 2px solid #ededed" class="black--text font-weight-bold" @click="moveToFreez"
          v-if="!showFeaturedProcess">
          <v-list-item-icon class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="17.645" height="17.645" viewBox="0 0 17.645 17.645">
              <g id="Icon_feather-minus-square" data-name="Icon feather-minus-square" transform="translate(-4 -4)">
                <path id="Path_5862" data-name="Path 5862"
                  d="M6.349,4.5H19.3a1.849,1.849,0,0,1,1.849,1.849V19.3A1.849,1.849,0,0,1,19.3,21.145H6.349A1.849,1.849,0,0,1,4.5,19.3V6.349A1.849,1.849,0,0,1,6.349,4.5Z"
                  fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1" />
                <path id="Path_5863" data-name="Path 5863" d="M12,18h7.4" transform="translate(-2.876 -5.178)"
                  fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1" />
              </g>
            </svg>
          </v-list-item-icon>
          <v-list-item-title>تجميد</v-list-item-title>
        </v-list-item>

        <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
          @click="acceptArchivedRequests">
          <v-list-item-icon class="ml-3">
            <v-icon >mdi-check-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>قبول الأرشفة</v-list-item-title>
        </v-list-item>

        <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
          @click="rejectArchivedRequests">
          <v-list-item-icon class="ml-3">
            <v-icon>mdi-close-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>رفض الأرشفة</v-list-item-title>
        </v-list-item>
        <v-list-item
          class="black--text font-weight-bold"
          style="border-bottom: 2px solid #ededed"
          @click="handleTransferToCustomerService"
        >
          <v-list-item-icon class="ml-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14.513"
              height="16.448"
              viewBox="0 0 14.513 16.448"
            >
              <path
                id="Icon_material-subdirectory-arrow-right"
                :fill="$store.getters.isDark ? '#ffffff' : '#000000'"
                data-name="Icon material-subdirectory-arrow-right"
                d="M20.513,16.643l-5.805,5.805-1.374-1.374,3.473-3.464H6V6H7.935v9.675h8.872l-3.473-3.464,1.374-1.374Z"
                transform="translate(-6 -6)"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-title>تحويل الطلب الي خدمة العملاء</v-list-item-title>
        </v-list-item>

        <v-list-item
          class="black--text font-weight-bold"
          style="border-bottom: 2px solid #ededed"
          @click="handleTransferToGeneralBasket"
        >
          <v-list-item-icon class="ml-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14.513"
              height="16.448"
              viewBox="0 0 14.513 16.448"
            >
              <path
                id="Icon_material-subdirectory-arrow-right"
                :fill="$store.getters.isDark ? '#ffffff' : '#000000'"
                data-name="Icon material-subdirectory-arrow-right"
                d="M20.513,16.643l-5.805,5.805-1.374-1.374,3.473-3.464H6V6H7.935v9.675h8.872l-3.473-3.464,1.374-1.374Z"
                transform="translate(-6 -6)"
              />
            </svg>
          </v-list-item-icon>
          <v-list-item-title>تحويل الطلب الى السله العامه</v-list-item-title>
        </v-list-item>

        <v-list-item class="black--text font-weight-bold" style="border-bottom: 2px solid #ededed"
          @click="requestArchived" v-if="!showFeaturedProcess && currentRole == 7">
          <v-list-item-icon class="ml-3">
            <svg xmlns="http://www.w3.org/2000/svg" width="18.171" height="20.078" viewBox="0 0 18.171 20.078">
              <g id="Icon_feather-trash-2" data-name="Icon feather-trash-2" transform="translate(-4 -2.5)">
                <path id="Path_5856" data-name="Path 5856" d="M4.5,9H21.671" transform="translate(0 -2.184)" fill="none"
                  :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1" />
                <path id="Path_5857" data-name="Path 5857"
                  d="M20.855,6.816V20.171a1.908,1.908,0,0,1-1.908,1.908H9.408A1.908,1.908,0,0,1,7.5,20.171V6.816m2.862,0V4.908A1.908,1.908,0,0,1,12.27,3h3.816a1.908,1.908,0,0,1,1.908,1.908V6.816"
                  transform="translate(-1.092)" fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'"
                  stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_5858" data-name="Path 5858" d="M15,16.5v5.724" transform="translate(-3.823 -4.915)"
                  fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1" />
                <path id="Path_5859" data-name="Path 5859" d="M21,16.5v5.724" transform="translate(-6.007 -4.915)"
                  fill="none" :stroke="$store.getters.isDark ? '#fff' : '#2c2c2c'" stroke-linecap="round"
                  stroke-linejoin="round" stroke-width="1" />
              </g>
            </svg>
          </v-list-item-icon>
          <v-list-item-title>ارشفه الطلب</v-list-item-title>
        </v-list-item>

      </v-list>
    </v-menu>

    <v-menu offset-y nudge-top="-7">
      <template v-slot:activator="{ on, attrs }">
        <v-avatar size="45px" v-bind="attrs" v-on="on" style="z-index: 5; left: 80px; top: -53px; position: absolute">
          <svg width="512" height="512" viewBox="0 0 512 512" fill="#3f0e40" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M474.557 37.4414V168.577H328.851V37.4414H474.557ZM255.999 37.4414V474.557H37.4414V37.4414H255.999ZM474.557 197.719V314.281H328.851V197.719H474.556H474.557ZM474.557 343.422V474.557H328.851V343.422H474.556H474.557Z"
              fill="#3f0e40" />
          </svg>
        </v-avatar>
      </template>
      <v-list class="top-left-menu">
        <v-list-item @click="$store.state.views = 'default'" v-if="appearThirdView">
          <v-list-item-icon class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="#3F0E40">
              <rect x="2" y="5" width="12" height="3" fill="#3F0E40" />
              <rect x="2" y="10" width="12" height="3" fill="#3F0E40" />
              <rect x="2" y="16" width="12" height="3" fill="#3F0E40" />
              <rect x="2" y="21" width="12" height="3" fill="#3F0E40" />
              <rect x="16.4424" y="5" width="11.5385" height="8.65385" rx="1" fill="#3F0E40" />
              <rect x="16.4424" y="15.0957" width="11.5385" height="8.65385" rx="1" fill="#3F0E40" />
            </svg>
          </v-list-item-icon>

          <v-list-item-title style="line-height: 2">
            عرض الملفات
          </v-list-item-title>
        </v-list-item>

        <v-list-item class="pl-12" @click="$store.state.views = 'cards'" style="border-bottom: 2px solid #ededed">
          <v-list-item-icon class="ml-2">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#3F0E40" xmlns="http://www.w3.org/2000/svg">
              <g id="four-squares-icon 1">
                <g id="Group">
                  <path id="Vector" fill-rule="evenodd" clip-rule="evenodd"
                    d="M2.61524 12.7831H10.4074C10.7402 12.7831 11.0124 13.1075 11.0124 13.5034V21.0877C11.0124 21.4842 10.7404 21.8083 10.4074 21.8083H2.61524C2.28272 21.8083 2.01025 21.4842 2.01025 21.0877V13.5034C2.01025 13.1075 2.28272 12.7831 2.61524 12.7831ZM13.5925 2H21.3848C21.7178 2 21.9898 2.32407 21.9898 2.72043V10.3048C21.9898 10.7011 21.7178 11.0249 21.3848 11.0249H13.5925C13.2596 11.0249 12.988 10.7011 12.988 10.3048V2.72043C12.988 2.32407 13.2596 2 13.5925 2ZM2.60449 2H10.3971C10.73 2 11.0021 2.32407 11.0021 2.72043V10.3048C11.0021 10.7011 10.7302 11.0249 10.3971 11.0249H2.60449C2.27197 11.0249 2 10.7011 2 10.3048V2.72043C2 2.32407 2.27197 2 2.60449 2ZM13.6027 12.9753H21.3951C21.7276 12.9753 22 13.2994 22 13.6959V21.2803C22 21.6761 21.7276 22.0002 21.3951 22.0002H13.6027C13.2699 22.0002 12.9977 21.6761 12.9977 21.2803V13.6959C12.9977 13.2994 13.2699 12.9753 13.6027 12.9753Z"
                    fill="#3F0E40" />
                </g>
              </g>
            </svg>
          </v-list-item-icon>
          <v-list-item-title style="line-height: 2">
            عرض الكروت</v-list-item-title>
        </v-list-item>

        <v-list-item class="pl-12" @click="$store.state.views = 'table'" style="border-bottom: 2px solid #ededed">
          <v-list-item-icon class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="27.348" height="22.783" viewBox="0 0 24.348 19.783"
              fill="#3F0E40">
              <path id="Icon_awesome-list-ul" data-name="Icon awesome-list-ul"
                d="M22.065,3.375a2.283,2.283,0,1,1-2.283,2.283A2.283,2.283,0,0,1,22.065,3.375Zm0,7.609a2.283,2.283,0,1,1-2.283,2.283A2.283,2.283,0,0,1,22.065,10.984Zm0,7.609a2.283,2.283,0,1,1-2.283,2.283,2.283,2.283,0,0,1,2.283-2.283Zm-21.3.761H15.978a.761.761,0,0,1,.761.761v1.522a.761.761,0,0,1-.761.761H.761A.761.761,0,0,1,0,21.636V20.114A.761.761,0,0,1,.761,19.353Zm0-15.217H15.978a.761.761,0,0,1,.761.761V6.418a.761.761,0,0,1-.761.761H.761A.761.761,0,0,1,0,6.418V4.9A.761.761,0,0,1,.761,4.136Zm0,7.609H15.978a.761.761,0,0,1,.761.761v1.522a.761.761,0,0,1-.761.761H.761A.761.761,0,0,1,0,14.027V12.505A.761.761,0,0,1,.761,11.745Z"
                transform="translate(0 -3.375)" fill="#3F0E40" />
            </svg>
          </v-list-item-icon>
          <v-list-item-title style="line-height: 2">عرض الجدول</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-btn @click="$store.state.search_admin = true" fab class="mx-2 pa-0 genaralIcons" small
      style="left: 125px; border-radius: 8px" :color="$vuetify.theme.themes.light.BtnBKColor" depressed width="40"
      height="40">
      <v-icon color="white">mdi-magnify</v-icon>
    </v-btn>

    <v-btn v-if="$store.state.views === 'table' && $route.name == ' all'"
      @click="$store.state.showSearchInputs = !$store.state.showSearchInputs" fab class="mx-2 pa-0 genaralIcons" small
      style="left: 175px; border-radius: 8px" :color="$vuetify.theme.themes.light.BtnBKColor" depressed width="40"
      height="40">
      <v-icon color="white">mdi-search-web</v-icon>
    </v-btn>

    <v-btn v-if="$store.state.views === 'table' && $route.name == ' all'"
      style="z-index: 5; left: 225px; top: -50px; position: absolute" title="excel" depressed width="40" height="40"
      :color="$vuetify.theme.themes.light.dataActionBTN" dark fab class="mx-2 pa-0 genaralIcons" @click="exportExcel">
      <svg xmlns="http://www.w3.org/2000/svg" width="18.116" height="18.116" viewBox="0 0 12.25 14">
        <g id="excel-file" transform="translate(-1.5)">
          <path id="Path_4097" data-name="Path 4097"
            d="M11.708,14H1.792a.292.292,0,0,1-.292-.292V3.548a.292.292,0,0,1,.074-.194L4.491.1A.292.292,0,0,1,4.708,0h7A.292.292,0,0,1,12,.292V7a.292.292,0,0,1-.583,0V.583H4.839L2.083,3.659v9.757h9.333V12.25a.292.292,0,1,1,.583,0v1.458A.293.293,0,0,1,11.708,14Z"
            fill="#fff" />
          <path id="Path_4098" data-name="Path 4098"
            d="M4.917,4.292H2.292a.292.292,0,0,1,0-.583H4.625V.792a.292.292,0,0,1,.583,0V4A.292.292,0,0,1,4.917,4.292Zm8.167,8.167h-7a.876.876,0,0,1-.875-.875v-3.5a.876.876,0,0,1,.875-.875h7a.876.876,0,0,1,.875.875v3.5A.876.876,0,0,1,13.083,12.458Zm-7-4.667a.292.292,0,0,0-.292.292v3.5a.292.292,0,0,0,.292.292h7a.293.293,0,0,0,.292-.292v-3.5a.293.293,0,0,0-.292-.292Z"
            transform="translate(-0.208 -0.208)" fill="#fff" />
          <path id="Path_4099" data-name="Path 4099"
            d="M11.29,15.67,10.566,14.6h.3a.075.075,0,0,1,.047.012.1.1,0,0,1,.027.03l.572.878a.4.4,0,0,1,.032-.07l.54-.8a.186.186,0,0,1,.03-.036.058.058,0,0,1,.039-.012h.283l-.726,1.052.751,1.139h-.293a.079.079,0,0,1-.053-.017.176.176,0,0,1-.031-.038l-.588-.919a.316.316,0,0,1-.027.061l-.572.858a.21.21,0,0,1-.032.039.065.065,0,0,1-.05.018h-.275l.755-1.125Zm1.754.876h.948V16.8H12.747V14.6h.3Zm2.4-1.6a.117.117,0,0,1-.03.034.059.059,0,0,1-.039.012.111.111,0,0,1-.061-.026q-.042-.031-.086-.058a.805.805,0,0,0-.128-.057.558.558,0,0,0-.18-.026.575.575,0,0,0-.176.027.377.377,0,0,0-.128.073.279.279,0,0,0-.076.109.348.348,0,0,0-.026.134.243.243,0,0,0,.045.152.385.385,0,0,0,.119.1.952.952,0,0,0,.168.074l.193.065c.065.023.131.048.192.075a.658.658,0,0,1,.168.107.486.486,0,0,1,.12.158.515.515,0,0,1,.045.229.735.735,0,0,1-.049.269.632.632,0,0,1-.143.22.672.672,0,0,1-.231.146.849.849,0,0,1-.311.054.956.956,0,0,1-.389-.077.908.908,0,0,1-.3-.209l.086-.14a.107.107,0,0,1,.03-.029.07.07,0,0,1,.038-.012.118.118,0,0,1,.073.034.946.946,0,0,0,.1.076.608.608,0,0,0,.366.107.577.577,0,0,0,.188-.029.378.378,0,0,0,.258-.373.269.269,0,0,0-.045-.163.38.38,0,0,0-.118-.106.832.832,0,0,0-.167-.072l-.192-.061a2.009,2.009,0,0,1-.192-.073.608.608,0,0,1-.167-.109.484.484,0,0,1-.118-.164.571.571,0,0,1-.045-.244.579.579,0,0,1,.177-.418.622.622,0,0,1,.211-.134.75.75,0,0,1,.29-.05.921.921,0,0,1,.335.058.773.773,0,0,1,.264.169l-.072.141Z"
            transform="translate(-3.765 -6.075)" fill="#fff" />
        </g>
      </svg>
    </v-btn>
    <v-menu offset-y nudge-top="-7">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" fab class="mx-2 pa-0 genaralIcons" small
          style="left: 275px; border-radius: 8px" :color="$vuetify.theme.themes.light.BtnBKColor" depressed width="40"
          height="40" title="ترتيب حسب">
          <v-icon color="white">mdi-sort</v-icon>
        </v-btn>
      </template>
      <v-list class="top-left-menu">
        <v-list-item v-for="option in orderByOptions" :key="option.id" @click="handleOrderByChange(option.id)">
          <v-list-item-title>{{ option.text }}</v-list-item-title>
          <v-list-item-icon v-if="selectedOrderById === option.id" class="mr-0">
            <v-icon small>mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>


    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent width="auto">
          <v-card>
            <v-card-title class="text-h5"> </v-card-title>
            <v-card-text>
              {{ messages }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="dialog = false">
                الغاء
              </v-btn>
              <v-btn color="green-darken-1" variant="text" @click="sureToArchive">
                متاكد
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <TransferFilterDialog :selectedItems="selectedItems" :type="type" />
    <TransferFilterDialogForCustomerService :selectedItems="selectedItems" :type="type" />
    <TransferFilterDialogForGeneralBasket :selectedItems="selectedItems" :type="type" />

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogQuality" persistent width="624">
          <v-card>
            <v-card-title>
              <span class="text-h5" style="margin-bottom: 30px">نقل الطلب الي الجوده</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <SelectInput @selectedValues="getSelectedValueManger" :originalItems="qualityUsers"
                      label="الجوده" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue-darken-1" variant="text" @click="dialogQuality = false">
                الغاء
              </v-btn>
              <v-btn color="blue-darken-1" variant="text" @click="handleSendUserToAgent">
                تحويل
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-snackbar v-model="active" :color="snackColor" timeout="-1" right bottom class="ml-4" elevation="24"
      transition="fade-transition">
      <span class="font-weight-bold" style="font-size: 16px">{{
        snackMessage
      }}</span>
      <template v-slot:action>
        <v-btn icon small @click="active = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <template>
      <v-row justify="center">
        <v-dialog v-model="backToReceivedDialog" persistent width="650">
          <v-card>
            <v-card-title class="text-h5"> </v-card-title>
            <v-card-text>
              <h2>هل انت متأكد من ارجاع الطلبات لسلة المستلمه ؟</h2>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="backToReceivedDialog = false">
                الغاء
              </v-btn>
              <v-btn color="green-darken-1" variant="text" @click="sureToBackToReceivedBasket">
                متاكد
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>


    <template>
      <v-row justify="center">
        <v-dialog v-model="acceptArchiveDialog" persistent width="650">
          <v-card>
            <v-card-title class="text-h5"> </v-card-title>
            <v-card-text>
              <h2>هل أنت متأكد من قبول أرشفة هذه الطلبات؟</h2>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="acceptArchiveDialog = false">
                إلغاء
              </v-btn>
              <v-btn color="green-darken-1" variant="text" @click="sureToAcceptArchive">
                متأكد
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="archiveClassificationDialog" persistent width="650">
          <v-card>
            <v-card-title class="text-h5">
              <span>اختر التصنيف السلبي للأرشفة</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      :items="negativeClassifications"
                      v-model="selectedClassification"
                      label="التصنيف السلبي"
                      item-text="value"
                      item-value="id"
                      outlined
                      dense
                      :rules="[v => !!v || 'يرجى اختيار التصنيف السلبي']"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="archiveClassificationDialog = false">
                إلغاء
              </v-btn>
              <v-btn color="green-darken-1" variant="text" @click="sureToArchiveWithClassification" :disabled="!selectedClassification">
                تأكيد الأرشفة
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="rejectArchiveDialog" persistent width="650">
          <v-card>
            <v-card-title class="text-h5"> </v-card-title>
            <v-card-text>
              <h2>هل أنت متأكد من رفض أرشفة هذه الطلبات وإرجاعها للمستلمة؟</h2>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="rejectArchiveDialog = false">
                إلغاء
              </v-btn>
              <v-btn color="green-darken-1" variant="text" @click="sureToRejectArchive">
                متأكد
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- ============================================================================ -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="backToCsReceivedDialog" persistent width="650">
          <v-card>
            <v-card-title class="text-h5">
              إرجاع لسلة مستلمة خدمة العملاء
            </v-card-title>
            <v-card-text>
              <p class="mb-4">
                سيتم إرجاع الطلبات المحددة التي لدى خدمة العملاء فقط، وتخطي الباقي.
              </p>
              <v-textarea
                v-model="csBackReason"
                label="سبب الإرجاع"
                outlined
                dense
                rows="3"
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="backToCsReceivedDialog = false">
                إلغاء
              </v-btn>
              <v-btn
                color="green-darken-1"
                variant="text"
                :disabled="csBackLoading"
                :loading="csBackLoading"
                @click="sureToBackToCsReceivedBasket"
              >
                تأكيد الإرجاع
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- ============================================================================ -->

    <template>
      <v-row justify="center">
        <v-dialog v-model="csBackResultDialog" persistent width="700" scrollable>
          <v-card>
            <v-card-title class="text-h5">
              نتيجة الإرجاع لخدمة العملاء
            </v-card-title>
            <v-card-text style="max-height: 400px">
              <p class="mb-4">{{ csBackResultMessage }}</p>

              <div v-if="csBackResult.success.length" class="mb-4">
                <h3 class="green--text mb-2">
                  تم الإرجاع ({{ csBackResult.success.length }})
                </h3>
                <v-chip
                  v-for="item in csBackResult.success"
                  :key="'success-' + item.request_id"
                  class="ma-1"
                  color="green"
                  text-color="white"
                  small
                >
                  #{{ item.request_id }}
                </v-chip>
              </div>

              <div v-if="csBackResult.failed.length">
                <h3 class="red--text mb-2">
                  لم يتم الإرجاع ({{ csBackResult.failed.length }})
                </h3>
                <v-list dense>
                  <v-list-item
                    v-for="item in csBackResult.failed"
                    :key="'failed-' + item.request_id"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        طلب #{{ item.request_id }}
                      </v-list-item-title>
                      <v-list-item-subtitle class="red--text">
                        {{ item.reason }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green-darken-1" variant="text" @click="csBackResultDialog = false">
                إغلاق
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

  </div>
</template>

<style lang="scss">
.genaralIcons {
  position: absolute;
  top: -50px;
  min-width: unset;
  z-index: 5;
}

.header__icons .v-input__slot {
  border: 1px solid white;
}

@media screen and (max-width: 626px) {
  .genaralIcons {
    top: -10px;
  }
}

.white-border {
  .v-input--outlined {
    border-color: white !important;
    /* Set the border color to white */
  }

  .v-label {
    color: white !important;
    /* Set the label color to white */
  }

  .v-icon {
    color: white !important;
    /* Set the icon color to white */
  }

  input {
    color: white !important;
    /* Set the input text color to white */
  }
}
</style>

<script>
import Axios from "axios";
import TransferFilterDialog from "@/components/AdminComponent/TransferFilterDialog.vue";
import TransferFilterDialogForCustomerService from "@/components/AdminComponent/TransferFilterDialogForCustomerService.vue";
import TransferFilterDialogForGeneralBasket from "@/components/AdminComponent/TransferFilterDialogForGeneralBasket.vue";
import SelectInput from "@/components/Charts/SelectInput.vue";
import { qualityUser } from "@/mixins/qualityUser";
import { SendToQualityIcon } from "@/assets/adminIcons/sendToQualityIcon";

export default {
  name: "HeaderIcons",
  components: {
    SelectInput,
    TransferFilterDialog,
    SendToQualityIcon,
    TransferFilterDialogForCustomerService,
    TransferFilterDialogForGeneralBasket
  },
  props: ["selectedItems", "startItems", "type"],
  data() {
    return {
      currentRole: 0,
      qualityUsers: [],
      active: false,
      AllSelectedTable: [],
      //=======================================================
      dialog: false,
      backToReceivedDialog: false,
      backToCsReceivedDialog: false,
      csBackResultDialog: false,
      csBackReason: "",
      csBackLoading: false,
      csBackResultMessage: "",
      csBackResult: {
        success: [],
        failed: [],
      },
      //=======================================================
      message: "",
      snackColor: "",
      messages: "هل انت متاكد من رغبتك في ارشفت هذه الطلبات",
      allStatus: [],
      dialogQuality: false,
      selectedQuality: [],
      needToAction: [],
      snackMessage: "",

      acceptArchiveDialog: false,
      rejectArchiveDialog: false,
      archiveClassificationDialog: false,
      negativeClassifications: [],
      selectedClassification: null,
      selectedOrderById: "created_at",
      orderByOptions: [
        { id: "created_at", text: "تاريخ انشاء الطلب" },
        { id: "request_date", text: "تاريخ الطلب" },
        { id: "updated_at", text: "تاريخ التحديث" },
        { id: "agent_date", text: "تاريخ النزول عند الاستشاري" },
      ],
    };
  },
  computed: {
    appearThirdView() {
      return (
        window.location.pathname === "/admin/requests/featured" ||
        window.location.pathname === "/admin/requests/all"
      );
    },
    showFeaturedProcess() {
      return window.location.pathname === "/admin/requests/featured";
    },

    showNewView() {
      return window.location.pathname === "/admin/requests/all";
    },
  },
  methods: {
    handleOrderByChange(id) {
      this.selectedOrderById = id;
      this.$store.state.selectedOrderById = id;
      this.$emit("orderByChanged", id);
      this.$emit("getData");
    },
    appendOrderByToRequestsUrl(url) {
      if (!url || !/Requests/i.test(url) || !this.selectedOrderById) {
        return url;
      }

      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}order_by=${encodeURIComponent(
        this.selectedOrderById
      )}`;
    },


    //=======================================================
    collectSelectedRequestIds() {
      const ids = [];

      (this.selectedItems || []).forEach((item) => ids.push(item.id));
      (this.$store.state.startElement || []).forEach((item) => ids.push(item.id));

      return [...new Set(ids)];
    },
    //=======================================================

    appendRequestIdsToFormData(body, fieldName = "request_ids") {
      this.collectSelectedRequestIds().forEach((id, index) => {
        body.append(`${fieldName}[${index}]`, id);
      });
    },

    acceptArchivedRequests() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.acceptArchiveDialog = true;
      }
    },

    rejectArchivedRequests() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.rejectArchiveDialog = true;
      }
    },

    sureToAcceptArchive() {
      this.acceptArchiveDialog = false;

      let url = `${this.$store.state.url}/v2/employee/acceptArchivedInQualityRequestArray`;
      let body = new FormData();

      this.selectedItems.length &&
        this.selectedItems.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      this.$store.state.startElement.length &&
        this.$store.state.startElement.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
        .then((res) => {
          this.snackMessage = res.data.message;
          this.snackColor = "green";
          this.active = true;
          this.$emit("getData");
        })
        .catch((err) => {
          let error = { err };
          this.snackMessage = error.err.response.data.message;
          this.snackColor = "red";
          this.active = true;
        });
    },

    sureToRejectArchive() {
      this.rejectArchiveDialog = false;

      let url = `${this.$store.state.url}/v2/employee/RestoreArchivedInQualityRequestToReceivedArray`;
      let body = new FormData();

      this.selectedItems.length &&
        this.selectedItems.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      this.$store.state.startElement.length &&
        this.$store.state.startElement.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
        .then((res) => {
          this.snackMessage = res.data.message;
          this.snackColor = "green";
          this.active = true;
          this.$emit("getData");
        })
        .catch((err) => {
          let error = { err };
          this.snackMessage = error.err.response.data.message;
          this.snackColor = "red";
          this.active = true;
        });
    },

    exportExcel() {
      this.$emit("exportExcel");
    },
    handleTableDesign() {
      this.$store.state.views = "table";
    },

    handleSendUserToAgent() {
      this.dialogQuality = false;

      let url =
        `${this.$store.state.url}/v2/employee/Requests/moveToQualityReqArray`;
      let body = new FormData();

      this.selectedQuality.forEach((item, index) => {
        body.append(`quality[${index}]`, item["id"]);
      });

      this.selectedItems.length &&
        this.selectedItems.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      this.$store.state.startElement.length &&
        this.$store.state.startElement.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
        .then((res) => {
          this.snackMessage = res.data.message;
          this.snackColor = "green";
          this.active = true;
        })
        .catch((err) => {
          let error = { err };
          this.snackMessage = error.err.response.data.message;
          this.snackColor = "red";
          this.active = true;
        });
    },

    getSelectedValueManger(val) {
      this.selectedQuality = val;
    },
    convertRequest() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.dialogQuality = true;

        qualityUser(this).then((res) => {
          console.log("res.data.payload", res.data.payload);
          this.qualityUsers = res.data.payload.map((item) => {
            item["color"] = "red";
            item["text"] = item["name_for_admin"] || item["name"];
            return item;
          });
        });
      }
    },

    moveToNeedAction() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.messages = "هل انت متأكد من تحويل هذه الطلبات";
        this.dialog = true;
      }
    },

    moveToFreez() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.messages = "  هل انت متأكد من تحويل هذه الطلبات الي سله التجميد";
        this.dialog = true;
      }
    },

    handleTurnuser() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.$store.state.turnuserDialog = true;
      }
    },

    handleTransferFilter() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.$store.state.TransferFilterDialog = true;
      }
    },
    

    handleTransferToCustomerService() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.$store.state.TransferFilterDialogForCustomerService = true;
      }
    },

    handleTransferToGeneralBasket() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.$store.state.TransferFilterDialogForGeneralBasket = true;
      }
    },

    requestArchived() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.getNegativeClassifications();
        this.archiveClassificationDialog = true;
      }
    },
    
    getNegativeClassifications() {
      Axios.get(`${this.$store.state.url}/agent/Request/Classification`, {
        headers: this.request_headers()
      })
        .then((res) => {
          // Filter only negative classifications (type = 0)
          this.negativeClassifications = res.data.payload.filter(
            (classification) => classification.class_type === 0
          );
        })
        .catch((err) => {
          this.snackMessage = "حدث خطأ أثناء تحميل التصنيفات";
          this.snackColor = "red";
          this.active = true;
        });
    },
    
    sureToArchiveWithClassification() {
      if (!this.selectedClassification) {
        this.snackMessage = "يرجى اختيار التصنيف السلبي";
        this.snackColor = "red";
        this.active = true;
        return;
      }
      
      this.archiveClassificationDialog = false;
      
      let url = `${this.$store.state.url}/v2/employee/Requests/Archive`;
      let body = new FormData();
      
      body.append("classification_id", this.selectedClassification);
      
      this.selectedItems.length &&
        this.selectedItems.forEach((item, index) => {
          body.append(`requests_ids[${index}]`, item["id"]);
        });

      this.$store.state.startElement.length &&
        this.$store.state.startElement.forEach((item, index) => {
          body.append(`requests_ids[${index}]`, item["id"]);
        });

      Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
        .then((res) => {
          this.snackMessage = res.data.payload || "تمت الأرشفة بنجاح";
          this.snackColor = "green";
          this.active = true;
          this.selectedClassification = null;
          this.$emit("getData");
        })
        .catch((err) => {
          let error = { err };
          this.snackMessage = error.err.response?.data?.message || "حدث خطأ أثناء الأرشفة";
          this.snackColor = "red";
          this.active = true;
        });
    },

    //=======================================================
    backToCustomerServiceRecievedBasket() {
      if (this.collectSelectedRequestIds().length) {
        this.csBackReason = "";
        this.backToCsReceivedDialog = true;
      }
    },
    //=======================================================
    sureToBackToCsReceivedBasket() {
      const reason = this.csBackReason.trim();
      if (reason.length > 0 && reason.length < 3) {
        return;
      }

      this.csBackLoading = true;
      const url = `${this.$store.state.url}/v2/employee/Requests/moveCsRequestsToReceived`;
      const body = new FormData();

      this.appendRequestIdsToFormData(body);
      if (reason.length > 0) {
        body.append("back_reason", reason);
      }

      Axios.post(this.appendOrderByToRequestsUrl(url), body, {
        headers: this.request_headers(),
      })
        .then((res) => {
          this.backToCsReceivedDialog = false;
          this.csBackResult = res.data.payload || { success: [], failed: [] };
          this.csBackResultMessage = res.data.message;
          this.csBackReason = "";
          // this.csBackResultDialog = true;
          // if (this.csBackResult.success.length) {
          //   this.$emit("getData");
          // }

          this.snackMessage = this.csBackResultMessage;
          this.active = true;
        })
        .catch((err) => {
          this.snackMessage =
            err.response?.data?.message || "حدث خطأ أثناء إرجاع الطلبات";
          this.snackColor = "red";
          this.active = true;
        })
        .finally(() => {
          this.csBackLoading = false;
        });
    },
    //=======================================================

    backToReceivedBasket() {
      if (
        this.selectedItems.length ||
        this.$store.state.startElement.length > 0
      ) {
        this.backToReceivedDialog = true;
      }
    },

    sureToArchive() {
      if (this.messages === "هل انت متأكد من تحويل هذه الطلبات") {
        this.dialog = false;
        let url =
          `${this.$store.state.url}/v2/employee/Requests/moveToNeedActionReqArray`;
        let body = new FormData();
        this.selectedItems.length > 0 &&
          this.selectedItems.forEach((item, index) => {
            body.append(`request_ids[${index}]`, item["id"]);
          });

        this.$store.state.startElement.length > 0 &&
          this.$store.state.startElement.forEach((item, index) => {
            body.append(`request_ids[${index}]`, item["id"]);
          });

        Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
          .then((res) => {
            this.snackMessage = res.data.message;
            this.snackColor = "green";
            this.active = true;
          })
          .catch((err) => {
            let error = { err };
            this.snackMessage = error.err.response.data.message;
            this.snackColor = "red";
            this.active = true;
          });
      } else if (
        this.messages === "هل انت متاكد من رغبتك في ارشفت هذه الطلبات"
      ) {
        let url =
          `${this.$store.state.url}/v2/employee/Requests/Archive`;
        let body = new FormData();

        this.selectedItems.length &&
          this.selectedItems.forEach((item, index) => {
            body.append(`requests_ids[${index}]`, item["id"]);
          });

        this.$store.state.startElement.length &&
          this.$store.state.startElement.forEach((item, index) => {
            body.append(`requests_ids[${index}]`, item["id"]);
          });

        this.dialog = false;

        Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
          .then((res) => {
            this.snackMessage = res.data.payload;
            this.snackColor = "green";
            this.active = true;
          })
          .catch((err) => {
            let error = { err };
            this.snackMessage = error.err.response.data.message;
            this.snackColor = "red";
            this.active = true;
          });
      } else if (
        this.messages === "  هل انت متأكد من تحويل هذه الطلبات الي سله التجميد"
      ) {
        this.dialog = false;
        let url =
          `${this.$store.state.url}/v2/employee/Requests/transferToFreezeReqArray`;
        let body = new FormData();
        this.selectedItems.length &&
          this.selectedItems.forEach((item, index) => {
            body.append(`request_ids[${index}]`, item["id"]);
          });

        this.$store.state.startElement.length &&
          this.$store.state.startElement.forEach((item, index) => {
            body.append(`request_ids[${index}]`, item["id"]);
          });

        Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
          .then((res) => {
            this.snackMessage = res.data.message;
            this.snackColor = "green";
            this.active = true;
            this.$emit("getData");
          })
          .catch((err) => {
            let error = { err };
            this.snackMessage = error.err.response.data.message;
            this.snackColor = "red";
            this.active = true;
          });
      }
    },

    sureToBackToReceivedBasket() {
      let url =
        `${this.$store.state.url}/v2/employee/Requests/moveFromAllToRecieved`;
      let body = new FormData();
      this.selectedItems.length &&
        this.selectedItems.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      this.$store.state.startElement.length &&
        this.$store.state.startElement.forEach((item, index) => {
          body.append(`request_ids[${index}]`, item["id"]);
        });

      this.backToReceivedDialog = false;

      Axios.post(this.appendOrderByToRequestsUrl(url), body, { headers: this.request_headers() })
        .then((res) => {
          this.snackMessage = res.data.message;
          this.snackColor = "green";
          this.active = true;
          this.$emit("getData");
        })
        .catch((err) => {
          let error = { err };
          this.snackMessage = error.err.response.data.message;
          this.snackColor = "red";
          this.active = true;
        });
    },
  },
  mounted() {
    this.currentRole = localStorage["role"];
    this.$store.state.selectedOrderById =
      this.$store.state.selectedOrderById || this.selectedOrderById;
  },
};
</script>
